import React from "react";
import SectionHeading from "./SectionHeading";
import { LANDING } from "@/constants/testIds";

const PILLARS = [
  { label: "Discipline", value: "Selective" },
  { label: "Origination", value: "Proprietary" },
  { label: "Approach", value: "Asset-Backed" },
];

const PlatformOverview = () => {
  return (
    <section
      id="platform"
      data-testid={LANDING.platformOverview}
      className="relative py-32 lg:py-44 border-t border-[var(--kr-line-soft)]"
    >
      <div className="max-w-[1480px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-16">
          <div className="lg:col-span-6">
            <SectionHeading
              index="02"
              label="Platform Overview"
              title={
                <>
                  A disciplined platform in
                  <br />
                  strategic formation for an
                  <br />
                  <span className="italic text-[var(--kr-gold)]">
                    industrial capital
                  </span>{" "}
                  cycle.
                </>
              }
            />
          </div>

          <div className="lg:col-span-6 lg:pl-10 flex flex-col gap-12">
            <p className="text-[var(--kr-text-muted)] text-[17px] leading-[1.85] max-w-[58ch]">
              Kellermann Reid &amp; Co. is in strategic formation at the
              intersection of private credit and opportunistic industrial
              equity. The intended investment framework is focused on
              asset-backed, cash-flow supported and special-situation
              opportunities — sourced through long-standing operating, advisory
              and lending relationships, and underwritten with institutional
              rigour.
            </p>

            <div className="kr-rule" />

            <dl className="grid grid-cols-3 gap-6">
              {PILLARS.map((p) => (
                <div key={p.label}>
                  <dt className="font-mono-label text-[10px] text-[var(--kr-text-muted)] mb-3">
                    {p.label}
                  </dt>
                  <dd className="font-serif-display text-[var(--kr-text)] text-[1.5rem]">
                    {p.value}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlatformOverview;
